/* non minified install code:

<script type="text/javascript">
(function() {
    function loadWidget() {
        var widgetScript = document.createElement('script');
        widgetScript.type = 'text/javascript';
        widgetScript.async = true;
        widgetScript.src = 'https://${defaultHost}/apps/widget/v1/${tenantName}/${widgetId}/${locale}/embed.js';
        widgetScript.onload = widgetScript.onreadystatechange = function() {
            var rs = this.readyState;
            if (rs && rs !== 'complete' && rs !== 'loaded') return;
            try {
                // Add calls to AnswersWidget sdk here
            } catch (e) {}
        };
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(widgetScript, s);
    }
    if (window.addEventListener) {
        window.addEventListener('load', loadWidget);
    } else {
        window.attachEvent('onload', loadWidget);
    }
    window.AnswersWidget = {
        onLoaded: function(cb){
            window.AnswersWidget.queue.push(cb);
        },
        queue: []
    }
})()
</script>

*/
// tslint:disable-next-line:max-line-length
export var generateWidgetInstallationScript = function (defaultHost, widgetId, locale, tenantName) {
    return "<script type=\"text/javascript\">!function(){function e(){var e=document.createElement(\"script\");e.type=\"text/javascript\",e.async=!0,e.src=\"https://" + defaultHost + "/apps/widget/v1/" + tenantName + "/" + widgetId + "/" + locale + "/embed.js\";var t=document.getElementsByTagName(\"script\")[0];t.parentNode.insertBefore(e,t)}window.addEventListener?window.addEventListener(\"load\",e):window.attachEvent(\"onload\",e),window.AnswersWidget={onLoaded:function(e){window.AnswersWidget.queue.push(e)},queue:[]}}();</script>";
};
//# sourceMappingURL=widget-install-script-generator.js.map